import nohutluPilav from '../../images/tumbnail/nohutlu-pilav1727440296.jpg'
import pilavUstuTavukBir from '../../images/tumbnail/tavuklu-pilav-bir1727440298.jpg'
import pilavUstuTavukBirBucuk from '../../images/tumbnail/tavuklu-pilav-bir-buçuk1727440298.jpg'
import pilavUstuTavukluNohutluSalata from '../../images/tumbnail/tavuklu-nohutlu-pilav-üstü-salata1727440298.jpg'
import karısıkTavuklu from '../../images/tumbnail/karışık-tavuklu-pilav1727440295.jpg'
import pilavUstuTavukluKuru from '../../images/tumbnail/tavuklu-kurufasulyeli-pilav1727440298.jpg'
import porsiyonKuru from '../../images/tumbnail/kuru-prosiyon1727440296.jpg'
import pilavMenuBir from '../../images/tumbnail/kuru-pilav-menü1727440296.jpg'
import sporcuMenu from '../../images/tumbnail/sporcu-menu1727440297.jpg'
import pilavUstuSote from '../../images/tumbnail/pilav-ustu-tavuk-sote1727441528.jpg'
import mixMenu from '../../images/newProducts/mixMenu.jpg'
import solenMenu from '../../images/newProducts/SolenMenu.jpg'
import cobanSalata from '../../images/tumbnail/oban-salata1727440295.jpg'
import acıkAyran from '../../images/tumbnail/Açık Ayran (27,5 cl.)1727440294.jpg'
import cocaCola33cl from '../../images/tumbnail/Coca-Cola (33 cl.)1727440294.jpg'
import cocaColaZero33cl from '../../images/tumbnail/Coca-Cola Zero Sugar (33 cl.)1727440294.jpg'
import doganaySalgam from '../../images/tumbnail/Doğanay-Şalgam-Suyu-Acısız1727440294.jpg'
import sutasAyran30cl from '../../images/tumbnail/Sütaş Ayran (30 cl.)1727440297.jpg'
import cigerMenu from '../../images/tumbnail/cigermenu.png'
import kofteMenu from '../../images/tumbnail/kofteporsiyon.jpg'
import pilavUstuKavurma from '../../images/tumbnail/pilavustukavurma.jpg'
import kavurmaMenu from '../../images/tumbnail/kavurmamenu.jpg'
import etliNohut from '../../images/tumbnail/etlinohut.jpeg'
import mantı from '../../images/tumbnail/mantı.jpeg'
import belenTava from '../../images/tumbnail/belentava.jpeg'


const Products = [
  {
    imageUrl: nohutluPilav,
    title: 'Nohutlu Pilav',
    description: '300gr. nohut, pirinç pilavı',
    price: 120,
    quantity: 0,
    barcode: '1',
  },
  {
    imageUrl: pilavUstuTavukBir,
    title: 'Tavuklu Nohutlu Pilav',
    description: '350 gr. nohutlu pilav, 50 gr. tavuk',
    price: 170,
    quantity: 0,
    barcode: '2',
  },
  {
    imageUrl: pilavUstuTavukBirBucuk,
    title: 'Tavuklu Pilav (1,5)',
    description: '400 gr. pilav, 75 gr. tavuk',
    price: 230,
    quantity: 0,
    barcode: '3',
  },
  {
    imageUrl: pilavUstuTavukluNohutluSalata,
    title: 'Tavuklu Pilav Üzeri Salata',
    description: 'Tereyağlı Pirinç Pilavı Üstüne Tavuk ve Salata',
    price: 220,
    quantity: 0,
    barcode: '4',
  },
  {
    imageUrl: karısıkTavuklu,
    title: 'Karışık Tavuklu Pilav',
    description: 'Tavuklu pilav, salata, mısır',
    price: 350,
    quantity: 0,
    barcode: '5',
  },
  {
    imageUrl: porsiyonKuru,
    title: 'Kuru Porsiyon',
    description: 'Kuru Fasulye',
    price: 200,
    quantity: 0,
    barcode: '6',
  },
  {
    imageUrl: etliNohut,
    title: 'Etli Nohut',
    price: 250,
    quantity: 0,
    barcode: '7',
  },
  {
    imageUrl: belenTava,
    title: 'Güveçte Belen Tava',
    price: 450,
    quantity: 0,
    barcode: '7',
  },
  {
    imageUrl: mantı,
    title: 'Kayseri Mantısı',
    price: 350,
    quantity: 0,
    barcode: '7',
  },
  {
    imageUrl: pilavUstuTavukluKuru,
    title: 'Tavuklu Kurulu Pilav',
    description: 'Tereyağlı pirinç pilavı üzerine kuru fasulye',
    price: 250,
    quantity: 0,
    barcode: '8',
  },
  {
    imageUrl: pilavUstuSote,
    title: 'Pilav Üstü Tavuk Sote',
    description: 'Tereyağlı Pilav, Tavuk Sote',
    price: 250,
    quantity: 0,
    barcode: '10',
  },
  {
    imageUrl: pilavMenuBir,
    title: 'Ekonomik Menü',
    description: 'Tereyağlı kuru fasulye, tereyağlı pilav, kapalı ayran',
    price: 300,
    quantity: 0,
    barcode: '11',
  },
  {
    imageUrl: sporcuMenu,
    title: 'Sporcu Menü',
    description: '400gr. Tereyağlı Pirinç Pilavı + 120gr. Tavuk + Salata + Sütaş Ayran (30 cl.)',
    price: 360,
    quantity: 0,
    barcode: '12',
  },
  {
    imageUrl: mixMenu,
    title: 'Mix Menü',
    description: 'Tavuk Sote + Pirinç Pilavı + Kuru + Coca-Cola (27 cl.)',
    price: 360,
    quantity: 0,
    barcode: '13',
  },
  {
    imageUrl: pilavUstuKavurma,
    title: 'Pilav Üstü Kavurma',
    description: 'Tereyağlı Pirinç Pilavı + 100gr. Kavurma',
    price: 380,
    quantity: 0,
    barcode: '20',
  },
  {
    imageUrl: kavurmaMenu,
    title: 'Kavurma Tabağı',
    description: '150 gr kavurma 250 gr. Pilav domates ve soğan eşliğinde.',
    price: 420,
    quantity: 0,
    barcode: '20',
  },
  {
    imageUrl: solenMenu,
    title: 'Şölen Menü',
    description: 'Tavuk Sote + Pirinç Pilavı + Sütaş Ayran (30 cl.)',
    price: 380,
    quantity: 0,
    barcode: '15',
  },
  {
    imageUrl: cigerMenu,
    title: 'Pilav Üstü Arvanut Ciğeri',
    description: 'Arnavut Ciğeri + Tereyağlı Pirinç Pilavı',
    price: 350,
    quantity: 0,
    barcode: '16',
  },
  {
    imageUrl: kofteMenu,
    title: 'Köfte Porsiyon',
    description: '6 Adet Dana Köfte + Pirinç Pilavı',
    price: 400,
    quantity: 0,
    barcode: '17',
  },
  {
    imageUrl: cobanSalata,
    title: 'Çoban Salata',
    description: 'Domates + Salatalık + Zeytinyağı',
    price: 90,
    quantity: 0,
    barcode: '20',
  },

  {
    imageUrl: doganaySalgam,
    title: 'Doğanay Şalgam Suyu Acısız (30 cl.)',
    price: 40,
    quantity: 0,
    barcode: '21',
  },
  {
    imageUrl: cocaCola33cl,
    title: 'Coca-Cola (33 cl.)',
    price: 70,
    quantity: 0,
    barcode: '23',
  },
  {
    imageUrl: cocaColaZero33cl,
    title: 'Coca-Cola Zero Sugar (33 cl.)',
    price: 70,
    quantity: 0,
    barcode: '24',
  },
  {
    imageUrl: acıkAyran,
    title: 'Açık Ayran (33 cl.)',
    price: 50,
    quantity: 0,
    barcode: '25',
  },
  {
    imageUrl: sutasAyran30cl,
    title: 'Sütaş Ayran (30 cl.)',
    price: 50,
    quantity: 0,
    barcode: '26',
  },
]

export default Products
